import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "core/gd-components/base-component/base-component";

import { when } from 'simply-deferred';

import IFrame from './iframe';

class ModalOriginalEmail extends BaseComponent {

    static propTypes = {
        params: PropTypes.shape({
            taskId: PropTypes.string,
            taskMessageId: PropTypes.string,
        })
    };

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        const cssLoader = gd.skin.loadDeferred("modals", "original-email");

        const request = gd.api.Task.originalEmail(this.props.taskId, this.props.taskMessageId);

        request.done((response)=>{
            this.originalEmail = response;
        });

        when(cssLoader, request).then(()=>{
            this.setState({
                isLoading: false
            })
        });
    }


    renderLoading() {
        return (
            <div>Loading...</div>
        )
    }

    render() {

        if (this.state.isLoading) {
            return this.renderLoading();
        }

        return (
            <IFrame email={this.originalEmail} />
        );
    }
}

module.exports = ModalOriginalEmail;